import { render, staticRenderFns } from "./Pagination.vue?vue&type=template&id=fad60176&scoped=true&"
import script from "./Pagination.vue?vue&type=script&lang=tsx&"
export * from "./Pagination.vue?vue&type=script&lang=tsx&"
import style0 from "./Pagination.vue?vue&type=style&index=0&id=fad60176&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fad60176",
  null
  
)

export default component.exports